import { useEffect } from 'react';
var key = 'CONSOLE_EVENTSOURCE';
export function dispatchEventSourceEvent(data) {
  var iEvent = new Event(key);
  iEvent.key = key;
  iEvent.newValue = data;
  window.dispatchEvent(iEvent);
}
export function addEventSourceListener(callback) {
  function _eventFn(e) {
    callback(e.newValue);
  }

  window.addEventListener(key, _eventFn);
  return function () {
    window.removeEventListener(key, _eventFn);
  };
}
export function useEventSourceListener(callback) {
  useEffect(function () {
    var unmount = addEventSourceListener(callback);
    return function () {
      unmount();
    };
  }, [callback]);
}